import { ApplicationState } from '../../../models/applications/enum';

export const isApplicationHasStatusWorkOrHigher = (state: ApplicationState) => {
  return (
    state !== ApplicationState.DRAFT &&
    state !== ApplicationState.UNDER_CONSIDERATION
  );
};
